import { useEffect } from 'react';
import { FaArrowLeft} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import styles from './PrivacyPolicy.module.css';

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.container}>
      {/* Header */}
      <header className={styles.header}>
        <Link to="/" className={styles.backButton}>
          <FaArrowLeft /> Voltar para o Site
        </Link>
        <div className={styles.logoSection}>
          <h1>Política de Privacidade</h1>
        </div>
      </header>

      {/* Conteúdo da Política */}
      <div className={styles.content}>
        <div className={styles.lastUpdated}>
          Última atualização: {new Date().toLocaleDateString('pt-BR')}
        </div>

        <section className={styles.section}>
          <h2>1. Introdução</h2>
          <p>
            A <strong>Cronos Agenda</strong> ("nós", "nosso" ou "a empresa"), operadora do site 
            <strong> cronosagenda.com.br</strong>, valoriza e respeita a sua privacidade. 
            Esta Política de Privacidade explica como coletamos, usamos, armazenamos e protegemos 
            as suas informações pessoais quando você utiliza nosso site e nossos serviços de agendamento.
          </p>
          <p>
            Ao acessar nosso site, se cadastrar e utilizar nossos serviços, você concorda com os 
            termos descritos nesta política.
          </p>
        </section>

        <section className={styles.section}>
          <h2>2. Quais Dados Coletamos?</h2>
          
          <h3>Dados Fornecidos por Você:</h3>
          <ul>
            <li><strong>Informações de Cadastro:</strong> Nome completo, endereço de e-mail, telefone, nome da empresa e senha de acesso.</li>
            <li><strong>Dados do Agendamento:</strong> Informações relacionadas aos agendamentos, como data, hora, tipo de serviço, nome do cliente e observações.</li>
            <li><strong>Dados de Pagamento:</strong> Processados diretamente por gateways de pagamento parceiras (não armazenamos em nossos servidores).</li>
            <li><strong>Dados de Contato:</strong> Conteúdo das mensagens e informações de contato quando você entra em contato conosco.</li>
          </ul>

          <h3>Dados Coletados Automaticamente:</h3>
          <ul>
            <li><strong>Dados de Navegação:</strong> Endereço de IP, tipo de navegador, páginas visitadas, tempo gasto no site e cookies.</li>
            <li><strong>Dados do Dispositivo:</strong> Tipo de dispositivo, sistema operacional e identificadores únicos.</li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2>3. Como Utilizamos os Seus Dados?</h2>
          <ul>
            <li>Fornecer e melhorar nossos serviços de agendamento</li>
            <li>Enviar lembretes e notificações importantes</li>
            <li>Prestar suporte ao cliente</li>
            <li>Enviar comunicações de marketing (com seu consentimento)</li>
            <li>Garantir a segurança da plataforma</li>
            <li>Cumprir obrigações legais</li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2>4. Base Legal para o Tratamento</h2>
          <p>Todo tratamento de dados é realizado com base legal de acordo com a LGPD:</p>
          <ul>
            <li><strong>Execução de Contrato:</strong> Para cumprir os serviços contratados</li>
            <li><strong>Consentimento:</strong> Para marketing e comunicações</li>
            <li><strong>Interesse Legítimo:</strong> Para melhorar nossos serviços e segurança</li>
            <li><strong>Cumprimento de Obrigação Legal:</strong> Para atender determinações legais</li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2>5. Compartilhamento de Dados</h2>
          <p>Seus dados podem ser compartilhados apenas com:</p>
          <ul>
            <li>Prestadores de serviços essenciais (hospedagem, gateway de pagamento, serviços de e-mail/SMS)</li>
            <li>Autoridades legais, quando exigido por lei</li>
            <li>Com seu consentimento explícito</li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2>6. Seus Direitos</h2>
          <p>De acordo com a LGPD, você tem direito a:</p>
          <div className={styles.rightsGrid}>
            <div className={styles.rightItem}>
              <h4>📋 Confirmação e Acesso</h4>
              <p>Saber quais dados temos sobre você</p>
            </div>
            <div className={styles.rightItem}>
              <h4>✏️ Correção</h4>
              <p>Atualizar dados incompletos ou incorretos</p>
            </div>
            <div className={styles.rightItem}>
              <h4>🗑️ Eliminação</h4>
              <p>Solicitar a exclusão de dados desnecessários</p>
            </div>
            <div className={styles.rightItem}>
              <h4>📤 Portabilidade</h4>
              <p>Receber seus dados em formato legível</p>
            </div>
            <div className={styles.rightItem}>
              <h4>🚫 Revogação</h4>
              <p>Revogar consentimentos a qualquer tempo</p>
            </div>
            <div className={styles.rightItem}>
              <h4>ℹ️ Informação</h4>
              <p>Saber com quem compartilhamos seus dados</p>
            </div>
          </div>
        </section>

        <section className={styles.section}>
          <h2>7. Segurança</h2>
          <p>
            Implementamos medidas de segurança técnicas e administrativas para proteger seus dados 
            contra acessos não autorizados, situações acidentais ou ilícitas de destruição, 
            perda, alteração, comunicação ou difusão.
          </p>
        </section>

        <section className={styles.section}>
          <h2>8. Cookies</h2>
          <p>
            Utilizamos cookies para melhorar sua experiência em nosso site. Você pode configurar 
            seu navegador para recusar cookies, mas algumas funcionalidades podem não funcionar 
            corretamente.
          </p>
        </section>

        <section className={styles.section}>
          <h2>9. Contato</h2>
          <p>
            Se você tiver alguma dúvida sobre esta Política de Privacidade ou desejar exercer 
            seus direitos, entre em contato conosco:
          </p>
          <div className={styles.contactInfo}>
            <p><strong>E-mail:</strong> dpo@cronosagenda.com.br</p>
            <p><strong>Site:</strong> cronosagenda.com.br</p>
          </div>
        </section>

        <div className={styles.actions}>
          <Link to="/" className={styles.homeButton}>
            Voltar para o Site Principal
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;